import React, { useEffect, useState } from 'react';
import useMobileCheck from './useMobileCheck';
import './desktopstyle.css';
import './mobilestyle.css';
const StageResultTable = ({
    selectedCompetition,
    selectedEventID,
    selectedCompetitionID,
    selectedGroupID,
    selectedStageID,
    selectedClassificationID
}) => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [colorMapping, setColorMapping] = useState({});
    const isMobile = useMobileCheck();
    
    const aligne = {
      // Horizontally align to center
      alignItems: 'center',     // Vertically align to center
    };
   
    const guestTextColors = [
      '#63AA57', '#6EB9E3', '#758AF8', '#8DEACE',
      '#B6F875', '#A2DDEA', '#9988FF', '#BECEF6', '#BCEAA0',
      '#ECA3A3', '#F5FF88', '#F875D3', '#FFBEA2', '#FFE5A2'
    ];
    // Function to create a color mapping for InGroup values
    const createColorMapping = (data) => {
      const colorMapping = {};
      let colorIndex = 0;
      data.forEach(item => {
        const inGroup = item.InGroup.trim();
        if (!colorMapping[inGroup]) {
          colorMapping[inGroup] = guestTextColors[colorIndex % guestTextColors.length];
          colorIndex++;
        }
      });
      return colorMapping;
    };


    useEffect(() => {
      
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/resultsGetPenaltiesForCompetition`;
    
        const getStageData = async () => {
          try {
            setLoading(true); // Set loading to true when starting to fetch data
            setError(null); // Reset the error state
    
            const response = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'UYwkNH50yAFoHI1mR62E'
              },
              body: JSON.stringify({
               
                StageID: selectedStageID,
                ClassificationID: selectedClassificationID
              }),
            });
    
            const data = await response.json();
            console.log(data)
            if ( response.status !== 200) { // Check if data.response exists before accessing code property
              setError('Brak Kar');
              setResults([]);
            } else {
              setResults(data);
              const newColorMapping = createColorMapping(data);
              setColorMapping(newColorMapping); // Set the colorMapping state
            }
          } catch (error) {
            console.error('Error fetching data:', error);
            setError('Error fetching data. Please try again.');
          } finally {
            setLoading(false);
          }
        };
    
        getStageData();
      }, [selectedStageID, selectedCompetitionID, selectedGroupID,selectedClassificationID]);

    const renderMobileItem = (result, index) => {
      const inGroup = (result.InGroup || '').trim();
      return (
        <div className="v2-card" key={index}>
          <div className="v2-left">
            <div className="v2-pos">{index + 1}</div>
            <div className="v2-num">#{result.PositionNumber}</div>
          </div>
          <div className="v2-middle">
            <div className="v2-d1">{(result.DriverName || '').trim()}</div>
            <div className="v2-d2">{(result.CODriverName || '').trim()}</div>
            <div className="v2-car-row">
              {inGroup && (
                <span
                  className="v2-class-badge"
                  style={{ background: colorMapping[inGroup] || '#71717a' }}
                >
                  {inGroup}
                </span>
              )}
              <span className="v2-car">{(result.Car || '').trim()}</span>
            </div>
            {result.Comments && (
              <div className="penalty-comment">{result.Comments}</div>
            )}
          </div>
          <div className="v2-right">
            <div className="penalty">
              <div className="penalty-text">+{result.Penalty}</div>
            </div>
          </div>
        </div>
      );
    };

    const containerClass = isMobile ? 'penalties-mobile-container' : 'dskt-table-container';

    return (
      <div className={containerClass}>
        <div className="has-text-centered ">
          <p className="title is-4"> </p>
        </div>
        {loading ? (
          <div className="loading-spinner">
            {/* Spinning arrow will be displayed here */}
          </div>
        ) : (
          <>
            {error ? (
              <div className="notification has-text-centered mt-1">
                <strong> {error}</strong>
              </div>
            ) : isMobile ? (
              <>
                <div className="mobile-stage-header__wrapper">
                  <div className="mobile-stage-header">
                    <div className="mobile-stage-header__title">Kary na odcinku</div>
                  </div>
                </div>
                {results.length ? (
                  <div className="columns result-table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <div>{results.map(renderMobileItem)}</div>
                  </div>
                ) : (
                  <div className="notification has-text-centered mt-1">
                    <strong>Brak danych</strong>
                  </div>
                )}
              </>
            ) : (
              <div className="desk-table-container penalties-table" style={aligne}>
                <div className="title">Kary na odcinku</div>
                <div className="tab-container">
                  <table>
                    <thead>
                      <tr className="table-header">
                        <th className="table-cell">#</th>
                        <th className="table-cell">Załoga</th>
                        <th className="table-cell">Samochód &amp; Klasa</th>
                        <th className="table-cell">Kara</th>
                        <th className="table-cell">Opis</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((result, index) => (
                        <tr className="table-row" key={index}>
                          <td className="table-cell">
                            <div className='position-badge-text'>
                              <div className="position-badge">{result.PositionNumber}</div>
                            </div>
                          </td>
                          <td className="table-cell table-cell-name">
                            <div style={{ whiteSpace: 'nowrap' }}>{result.DriverName}</div>
                            <div style={{ whiteSpace: 'nowrap' }}>{result.CODriverName}</div>
                          </td>
                          <td className="table-cell table-cell-car">
                            <div>{result.Car}</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                              <div className="guest-badge" style={{ background: colorMapping[result.InGroup.trim()] }}>
                                <div className="guest-badge-text">{result.InGroup}</div>
                              </div>
                            </div>
                          </td>
                          <td className="table-cell">
                            <div className="penalty">
                              <div className="penalty-text">+{result.Penalty}</div>
                            </div>
                          </td>
                          <td className="table-cell table-cell-comment">
                            <div>{result.Comments ? `${result.Comments}` : ''}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
};

export default StageResultTable;